import React from 'react'
import { useTranslation } from 'react-i18next'

import { User } from 'core/application/account/loginUser'

import './GreetingAdminMessage.less'

export enum GreetingStatus {
  SIGNED_UP = 'signedUp',
  TASKS_LEFT = 'tasksLeft',
  NO_TASKS_LEFT = 'noTasksLeft',
  GENERAL = 'general',
}

interface Status {
  status: GreetingStatus
  user: User
}

const GreetingAdminMessage: React.FC<Status> = ({ status, user }) => {
  const { t: translate } = useTranslation()

  const signUpWelcomeComponent = (name: string) => (
    <div>
      <h1>{translate('admin-dashboard.home.signup-welcome-header').replace('[NAME]', name)}</h1>
      <p>{translate('admin-dashboard.home.signup-welcome-first-sentence')}</p>
    </div>
  )

  const visitedBeforeComponent = (name: string) => (
    <div>
      <h1>{translate('admin-dashboard.home.visited-before-header').replace('[NAME]', name)}</h1>
      <p>{translate('admin-dashboard.home.visited-before-first-sentence')}</p>
    </div>
  )

  const generalComponent = (name: string) => (
    <div>
      <h1 className="text-left">{translate('admin-dashboard.home.welcome-header').replace('[NAME]', name)}</h1>
    </div>
  )

  const noTasksLeftComponent = (name: string) => (
    <div>
      <h1>{translate('admin-dashboard.home.no-tasks-welcome-header').replace('[NAME]', name)}</h1>
    </div>
  )

  let firstName = user.firstName
  const pickGreetingMessage = (status: string, firstName: string): React.ReactNode => {
    switch (status) {
      case GreetingStatus.SIGNED_UP:
        return signUpWelcomeComponent(firstName)
      case GreetingStatus.TASKS_LEFT:
        return visitedBeforeComponent(firstName)
      case GreetingStatus.GENERAL:
        return generalComponent(firstName)
      case GreetingStatus.NO_TASKS_LEFT:
        return noTasksLeftComponent(firstName)
      default:
        return noTasksLeftComponent(firstName)
    }
  }

  return <div className="greeting_message">{pickGreetingMessage(status, firstName)}</div>
}

export default GreetingAdminMessage
